import { useParams } from "react-router-dom";
import AccountReportHeader from "./components/AccountReportHeader";
import CashReceipts from "./components/CashReceipts";
import ClientRegistry from "./components/ClientRegistry";
import GeneralJournal from "./components/GeneralJournal";
import GeneralLedger from "./components/GeneralLedger";
import ReportTabs from "./components/ReportTabs";
import SeniorClientRegistry from "./components/SeniorClientRegistry";

const AccountReports = () => {
  const { id } = useParams();

  const items = [
    {
      title: "Cash Receipts",
      content: <CashReceipts id={id} />,
    },
    {
      title: "General Journal",
      content: <GeneralJournal id={id} />,
    },
    {
      title: "General Ledger",
      content: <GeneralLedger id={id} />,
    },
    {
      title: "Client Registry",
      content: <ClientRegistry id={id} />,
    },
    {
      title: "SC / PWD Registry",
      content: <SeniorClientRegistry id={id} />,
    },
  ];

  return (
    <div className="px-6 lg:px-0">
      <div className="card p-6">
        <AccountReportHeader id={id} />
      </div>
      <ReportTabs items={items} />
    </div>
  );
};

export default AccountReports;
